module.exports = __webpack_public_path__ + "static/media/Howard, Burlingame, CA3.ad14de09.jpg";